var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
var BetTypesItem = /** @class */ (function (_super) {
    __extends(BetTypesItem, _super);
    function BetTypesItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (e) {
            e.preventDefault();
            var props = _this.props;
            var data = {
                betType: props.betType
            };
            if (props.betType === 1) {
                data['rank'] = null;
            }
            props.selectBetTypeAction(data);
            props.saveBetTypeAction(data.betType);
        };
        return _this;
    }
    BetTypesItem.prototype.render = function () {
        var props = this.props;
        var betTypesLength = props.betTypes.size;
        var cls = betTypesLength > 1 && props.selectedBetType === props.betType ? 'active' : '';
        var data = {
            betType: props.betType
        };
        if (props.betType === 1) {
            data['rank'] = null;
        }
        return (_jsx("li", __assign({ className: cls }, { children: _jsx("a", __assign({ href: '#', onClick: this.onClick }, { children: props.msg })) })));
    };
    return BetTypesItem;
}(React.Component));
BetTypesItem.propTypes = {
    msg: PropTypes.object.isRequired,
    selectBetTypeAction: PropTypes.func.isRequired,
    betType: PropTypes.number.isRequired,
    selectedBetType: PropTypes.number.isRequired
};
export default BetTypesItem;



// WEBPACK FOOTER //
// ./src/components/coupon/betSlip/BetTypesItem.jsx